function ThankYouPage() {
  return (
    <div>
      <div className="content mt-5">
        <div className="container">
          <div className="card p-5">
            <div className="row">
              <div className="col-lg-12">
                <div className="">
                  <div className="">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="row mt-5">
                          <div className="col-sm-12 mb-2">
                            <h1 className="m-0 form-header">
                              Bedankt voor het Uploaden!
                            </h1>
                          </div>
                          <div className="col-sm-12 mb-2">
                            Het uploaden van uw documenten is gelukt en uw
                            aanvraag wordt beoordeeld.
                          </div>
                          <div className="col-sm-12">
                            Wij houden u per e-mail op de hoogte over uw
                            aanvraag, dus houd uw mailbox in de gaten.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div style={{ textAlign: "end" }}>
                          <img
                            src="../../dist/img/Illustration2.png"
                            alt="Logo"
                            style={{ opacity: ".8", width: 300 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYouPage;
